import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  menu: {
    marginTop: 0,
    '& .MuiPaper-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_600.main
          : theme.palette.common.white,
      borderRadius: 8,
      boxShadow: theme.shadows[8]
    }
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 16px',
    fontSize: '.875rem',
    borderRadius: 8,
    margin: '0 4px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_500.main
          : theme.palette.gray_100.main
    }
  },
  flexContainer: {
    display: 'flex',
    gap: '4px',
    padding: '8px 12px',
    alignItems: 'center'
  }
}))
